//#region src/version.ts
const version = "5.1.1";

//#endregion
export { version };
//# sourceMappingURL=version.js.map